// Custom scripts
import Towar from "./towar";


(() => {
  if (typeof $ === "undefined") {
    throw new TypeError("... requires jQuery.");
  }

  $(document).ready(() => {
    const t = new Towar();

    t.init();
  });
})();
